module.exports = __webpack_public_path__ + "static/media/state-planet-12.fa87433d.png";